import type { DeleteRecentRegionPayload } from '@weberus/shared-types';
import type { FetcherType } from '@/app/_shared/utils/fetcher/types';
import { useMutation } from '@tanstack/react-query';
import { clientFetcher } from '@/app/_shared/utils/fetcher/client-fetcher';

const deleteRegionRecentSelected =
  (fetcher: FetcherType) => (headers: Record<string, string>, payload: DeleteRecentRegionPayload) => {
    return fetcher<'', DeleteRecentRegionPayload>({
      method: 'DELETE',
      url: `/cx-display/recent-selected-region`,
      data: payload,
      headers,
    });
  };

export const useDeleteRegionRecentSelected = () => {
  return useMutation({
    mutationFn: (params: DeleteRecentRegionPayload) => {
      return deleteRegionRecentSelected(clientFetcher)({}, params);
    },
  });
};
